import React, { FC } from 'react';
import { useTranslate } from '@/translations';
import { AuthorizationStatus } from '@/types';
import { AuthorizationNotesModal } from './AuthorizationNotesModal';

interface ActionsPopupProps {
  visible: boolean;
  loading: boolean;
  onSubmit: (comment?: string) => Promise<void>;
  onClose: () => void;
  authorizationId?: number;
  authorizationStatus?: AuthorizationStatus;
  backToDefault?: boolean;
}
export const ActionsPopup: FC<ActionsPopupProps> = ({
  visible,
  onSubmit,
  loading,
  onClose,
  authorizationId,
  authorizationStatus,
  backToDefault,
}) => {
  const { t } = useTranslate();

  const title = t(
    backToDefault
      ? authorizationStatus === AuthorizationStatus.Approved
        ? 'unApproveStatusQuestion'
        : 'unRejectStatusQuestion'
      : authorizationStatus === AuthorizationStatus.Approved
        ? 'approveStatusQuestion'
        : 'rejectStatusQuestion',
  );

  return (
    <AuthorizationNotesModal
      visible={visible}
      title={title}
      loading={loading}
      onClose={onClose}
      isConfirmDisabled={(comment) =>
        (!comment || !comment.length) &&
        !backToDefault &&
        authorizationStatus === AuthorizationStatus.Rejected
      }
      onConfirm={async (comment) => {
        // API call is handled by the parent to reduce duplication and keep side-effects centralized.
        if (!authorizationId) throw new Error('Authorization id is missing.');
        await onSubmit(comment);
      }}
    />
  );
};
